<template>
    <div
        class="feature-list"
        :class="{ table: showLimits || showUserCounts, 'three-column': showLimits && showUserCounts }"
    >
        <div class="header"><span>Toggle to Allow</span></div>
        <div
            v-if="showLimits"
            class="header"
        >
            <span>Select Limit</span>
        </div>
        <div
            v-if="showUserCounts"
            class="header"
        >
            <span>User Count</span>
        </div>
        <!-- eslint-disable vue/no-v-for-template-key -->
        <template
            v-for="feature in availableFeatures"
            :key="`toggle${feature.id}`"
        >
            <!-- eslint-enable -->
            <div>
                <slider-toggle-field
                    :data-test-id="`feature-${feature.feature}-toggle`"
                    :label="feature.name"
                    :name="feature.feature"
                    :tooltip="feature.description"
                    :value="isFeatureEnabled(feature)"
                    @update="toggleFeature(feature)"
                ></slider-toggle-field>
            </div>
            <input
                v-if="showLimits"
                type="number"
                class="limit"
                :data-test-id="`feature-toggle-${feature.feature}-limit`"
                :value="limitValue(feature)"
                :disabled="!isFeatureEnabled(feature)"
                @input.prevent.stop="setLimit(feature, $event)"
            />
            <span
                v-if="showUserCounts"
                :data-test-id="`feature-toggle-${feature.feature}-count`"
            >
                {{ userCountValue(feature) }}
            </span>
        </template>
    </div>
</template>

<script>
import { closeModal, openModal } from 'jenesius-vue-modal'
import SliderToggleField from '@/components/SliderToggleField.vue'
import ConfirmModal from './Modal/ConfirmModal.vue'

export default {
    components: { SliderToggleField },

    props: {
        availableFeatures: Array,
        selectedFeatures: Object,
        userCounts: {
            type: Array,
            default: () => [],
        },
        showLimits: Boolean,
        showUserCounts: Boolean,
    },

    computed: {
        _selectedFeatures() {
            return this.selectedFeatures
        },
    },

    methods: {
        toggleFeature(feature, newValue) {
            const userCount = this.userCountValue(feature)
            const featureName = feature.is_premium ? 'premium mobile feature' : 'mobile feature'

            if (this.isFeatureEnabled(feature) && userCount > 0) {
                openModal(ConfirmModal, {
                    label: 'Are you sure?',
                    text: `You are about to remove a ${featureName} from an\
                        organization that has been assigned to users and/or groups\
                        within the organization.  Removing this feature could affect\
                        ${userCount} users. Are you sure you want to proceed with\
                        the removal?`,
                    confirm: () => {
                        closeModal()
                        this.$emit('toggle', feature)
                    },
                    cancel: () => {
                        closeModal()
                    },
                })
            } else {
                this.$emit('toggle', feature)
            }
        },

        setLimit(feature, e) {
            this.$emit('limit-update', feature, e.target.value)
        },

        isFeatureEnabled(feature) {
            return this._selectedFeatures[feature.id] !== undefined
        },

        limitValue(feature) {
            // if feature is selected, return limt, else return null
            return this.selectedFeatures[feature.id]?.limit ?? null
        },

        userCountValue(feature) {
            const count = this.userCounts.find((c) => c.feature_id === feature.id)
            if (count) {
                return count.user_count
            }

            return 0
        },
    },
}
</script>

<style lang="scss" scoped>
.feature-toggle.active .feature-toggle__label {
    color: #fff;
}

.feature-list {
    div:not(:last-child) {
        margin-bottom: 16px;
    }

    &.table {
        display: grid;
        grid-row-gap: 10px;
        grid-column-gap: 8px;
        align-items: center;
        justify-items: start;
        grid-template-columns: auto 80px;

        &.three-column {
            grid-template-columns: auto 80px 80px;
        }

        div:not(:last-child) {
            margin-bottom: 0;
        }
    }

    .feature-toggle__label {
        position: relative;
        top: 1px;
        margin-left: 5px;
        font-family: 'Avenir Book';
        font-size: 1.0625rem;
    }

    .header {
        align-self: end;

        span {
            font-family: 'Avenir Heavy';
            font-size: 0.9125em;
            color: #999;
            margin-bottom: 2px;
        }
    }
}
</style>
